import { Height } from '@atlassian/company-hub-common';

import { type CardsDimensions } from './types';

/**
 * Card dimensions for cards 1.0 and 2.0
 *
 * - The max number of cards per row determines the min width of different card sizes
 * - The max width is used in case the first row is not full
 */
export const cardsDimensions: CardsDimensions = {
	[Height.SMALL]: {
		minWidth: 221,
		maxWidth: 380,
		height: 72,
	},
	[Height.MEDIUM]: {
		minWidth: 240,
		maxWidth: 308,
		height: 312,
	},
	[Height.LARGE]: {
		minWidth: 358,
		maxWidth: 640,
		height: 312,
	},
};

export const cardsDimensionsV1: CardsDimensions = {
	[Height.SMALL]: {
		minWidth: 240,
		maxWidth: 294,
		height: 84,
	},
	[Height.MEDIUM]: {
		minWidth: 240,
		maxWidth: 294,
		height: 320,
	},
	[Height.LARGE]: {
		minWidth: 326,
		maxWidth: 392,
		height: 320,
	},
};

export const cardsDimensionsV2: CardsDimensions = {
	[Height.SMALL]: {
		...cardsDimensionsV1[Height.SMALL],
	},
	[Height.MEDIUM]: {
		minWidth: 240,
		maxWidth: 294,
		minHeight: 52,
		maxHeight: 348,
	},
	[Height.LARGE]: {
		minWidth: 326,
		maxWidth: 392,
		minHeight: 64,
		maxHeight: 424,
	},
};
